import { render, staticRenderFns } from "./ele.vue?vue&type=template&id=1b9cf884&scoped=true"
import script from "./ele.vue?vue&type=script&lang=js"
export * from "./ele.vue?vue&type=script&lang=js"
import style0 from "./ele.vue?vue&type=style&index=0&id=1b9cf884&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9cf884",
  null
  
)

export default component.exports